

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import Grid from 'web-library/stories/atom/Grid/Grid';
import Button from 'web-library/stories/atom/Button/Button';
import Link from 'web-library/stories/atom/Link/Link';
import Typography from 'web-library/stories/atom/Typography/Typography';
import SectionHeader from 'web-library/stories/molecule/SectionHeader/SectionHeader';
import RouteKey from '../../../routes/key';
import { candidateService } from '../../../api';
import ReceiptDetail from '../../../components/ReceiptDetails';
import { useWOGAA } from '../../../hooks/wogaa';


import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
  fullSummaryLabel: {
     ...typographyTheme(theme, 'h5'),
  },
}));

interface ExamReceiptPathParams {
  uuid?: string;
}

const { exam } = RouteKey.child;
const { examRegistrations, summary } = RouteKey.exam.child;

const { summary: paymentSummary } = RouteKey['payment-link'].child;
const { paymentLink } = RouteKey.child;

const ExamReceipt = ({
  toSummaryLink = '',
  isPaymentLink = false,
}: {
  toSummaryLink?: string;
  isPaymentLink?: boolean;
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { transactionEnd } = useWOGAA('myexamsseab-6451');
  const history = useHistory();
  const { uuid } = useParams<ExamReceiptPathParams>();
  const { data } = candidateService.exam.candidate.useGetExamTransactionInfo(uuid);
  let summaryUrl = `/${exam}/${examRegistrations.route}/${uuid}/${summary.route}`;
  if (toSummaryLink) {
    summaryUrl = `/${paymentLink}/exam-registration/${uuid}/${paymentSummary}`;
  }

    /** WOGAA complete transaction for registration flow
     * */
    transactionEnd(uuid);

  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <SectionHeader
            title={t('exam->>ExamReceipt.PaymentSummary')}
          >
            <Link id="link-viewFullSummary" onClick={() => history.push(summaryUrl)} withUnderline>
              <Typography className={classes.fullSummaryLabel}>
                {t('exam->>ExamReceipt.ViewFullSummary')}
              </Typography>
            </Link>
          </SectionHeader>
        </Grid>
      </Grid>

      <ReceiptDetail
        transaction={{
          transactionNumber: data?.transactionNumber || '',
          internalTransactionRef: data?.internalTransactionRef,
          totalFee: data?.totalFee || '0',
          paymentMethod: data?.paymentMethod || '',
          paymentTimeStamp: data?.paymentTimeStamp || '',
          gstRegNo: data?.gstRegNo,
        }}
      />

      {!isPaymentLink && (
        <Button
          id="button-examReceipt-goToRegisteredExams"
          className={classes.button}
          onClick={() => history.push(`/${exam}/${examRegistrations.route}`)}
        >
          {t('exam->>ExamReceipt.ViewRegisteredExam')}
        </Button>
      )}
    </>
  );
};
export default ExamReceipt;
